import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=1bc16b08&scoped=true&"
import script from "./UserManagement.vue?vue&type=script&lang=js&"
export * from "./UserManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=1bc16b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc16b08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc16b08')) {
      api.createRecord('1bc16b08', component.options)
    } else {
      api.reload('1bc16b08', component.options)
    }
    module.hot.accept("./UserManagement.vue?vue&type=template&id=1bc16b08&scoped=true&", function () {
      api.rerender('1bc16b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/settings/UserManagement.vue"
export default component.exports